/**
 * @generated SignedSource<<d034fddfa79573a30902695a177596dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppDialogActionEnum = "app_dialog_delete" | "app_dialog_update" | "%future added value";
export type AppDialogExposeHourEnum = "day" | "hour" | "month" | "%future added value";
export type AppDialogExposeTypeEnum = "always" | "hour_repeat" | "manual_tag" | "once" | "weekday_repeat" | "%future added value";
export type AppDialogExposeWeekdayEnum = "fri" | "mon" | "sat" | "sun" | "thu" | "tue" | "wed" | "%future added value";
export type AppDialogStatusEnum = "finished" | "ongoing" | "pending" | "%future added value";
export type AppDialogTypeEnum = "image" | "image_and_text" | "text" | "%future added value";
export type AppDialogId_appDialogQuery$variables = {
  id: string;
};
export type AppDialogId_appDialogQuery$data = {
  readonly appDialog: {
    readonly actions: ReadonlyArray<AppDialogActionEnum>;
    readonly appDeepLink: string | null;
    readonly appDialogBody: string | null;
    readonly appDialogButton: string | null;
    readonly appDialogImage: {
      readonly key: string;
      readonly objectUrl: string;
      readonly size: number;
    } | null;
    readonly appDialogMobileImage: {
      readonly key: string;
      readonly objectUrl: string;
      readonly size: number;
    } | null;
    readonly appDialogTabletImage: {
      readonly key: string;
      readonly objectUrl: string;
      readonly size: number;
    } | null;
    readonly appDialogTitle: string | null;
    readonly appDialogType: AppDialogTypeEnum;
    readonly created: any;
    readonly createdBy: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
    };
    readonly endAt: any;
    readonly exposeHour: AppDialogExposeHourEnum | null;
    readonly exposeTag: string | null;
    readonly exposeType: AppDialogExposeTypeEnum;
    readonly exposeWeekdays: ReadonlyArray<AppDialogExposeWeekdayEnum> | null;
    readonly id: string;
    readonly modified: any | null;
    readonly query: string | null;
    readonly startAt: any;
    readonly status: AppDialogStatusEnum;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"AppDialogDescriptionList_appDialog" | "AppDialogImageAndTextTypePreviewItem_appDialog" | "AppDialogImageTypePreviewItem_appDialog" | "AppDialogStatusLabel_appDialog" | "AppDialogTextTypePreviewItem_appDialog">;
  };
};
export type AppDialogId_appDialogQuery = {
  response: AppDialogId_appDialogQuery$data;
  variables: AppDialogId_appDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appDialogType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "query",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appDeepLink",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appDialogTitle",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appDialogBody",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appDialogButton",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modified",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exposeHour",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exposeType",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exposeTag",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exposeWeekdays",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectUrl",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v23 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v24 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppDialogId_appDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AppDialog",
        "kind": "LinkedField",
        "name": "appDialog",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserAvatarText_user"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "appDialogImage",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "appDialogMobileImage",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "appDialogTabletImage",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppDialogDescriptionList_appDialog"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppDialogStatusLabel_appDialog"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppDialogImageTypePreviewItem_appDialog"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppDialogImageAndTextTypePreviewItem_appDialog"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppDialogTextTypePreviewItem_appDialog"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppDialogId_appDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AppDialog",
        "kind": "LinkedField",
        "name": "appDialog",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "picture",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDeleted",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "appDialogImage",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "appDialogMobileImage",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "appDialogTabletImage",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "order",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "75697e8f7bc6fc7be2de8c5ab8882a51",
    "id": null,
    "metadata": {},
    "name": "AppDialogId_appDialogQuery",
    "operationKind": "query",
    "text": "query AppDialogId_appDialogQuery(\n  $id: ID!\n) {\n  appDialog(id: $id) {\n    id\n    createdBy {\n      id\n      ...UserAvatarText_user\n    }\n    actions\n    status\n    title\n    appDialogType\n    query\n    appDeepLink\n    appDialogTitle\n    appDialogBody\n    appDialogButton\n    startAt\n    endAt\n    created\n    modified\n    exposeHour\n    exposeType\n    exposeTag\n    exposeWeekdays\n    appDialogImage {\n      objectUrl\n      size\n      key\n      id\n    }\n    appDialogMobileImage {\n      objectUrl\n      size\n      key\n      id\n    }\n    appDialogTabletImage {\n      objectUrl\n      size\n      key\n      id\n    }\n    ...AppDialogDescriptionList_appDialog\n    ...AppDialogStatusLabel_appDialog\n    ...AppDialogImageTypePreviewItem_appDialog\n    ...AppDialogImageAndTextTypePreviewItem_appDialog\n    ...AppDialogTextTypePreviewItem_appDialog\n  }\n}\n\nfragment AppDialogDescriptionList_appDialog on AppDialog {\n  startAt\n  endAt\n  exposeType\n  exposeTag\n  exposeHour\n  exposeWeekdays\n  appDialogType\n  appDeepLink\n  appDialogMobileImage {\n    objectUrl\n    id\n  }\n  appDialogTabletImage {\n    objectUrl\n    id\n  }\n  appDialogImage {\n    objectUrl\n    id\n  }\n  order\n}\n\nfragment AppDialogImageAndTextTypePreviewItem_appDialog on AppDialog {\n  appDialogImage {\n    id\n    objectUrl\n    size\n  }\n  appDialogTitle\n  appDialogBody\n  appDialogButton\n}\n\nfragment AppDialogImageTypePreviewItem_appDialog on AppDialog {\n  appDialogMobileImage {\n    id\n    objectUrl\n    size\n  }\n  appDialogTabletImage {\n    id\n    objectUrl\n    size\n  }\n}\n\nfragment AppDialogStatusLabel_appDialog on AppDialog {\n  status\n}\n\nfragment AppDialogTextTypePreviewItem_appDialog on AppDialog {\n  appDialogTitle\n  appDialogBody\n  appDialogButton\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "0ec14901579a7ecce7dfaf2352476b41";

export default node;
